import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import {
  FormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ICustomerGenericService, IHIPGenericService } from '@huge-monorepo/shared/interfaces';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedGenericSingletonService } from '@huge-monorepo/shared/services';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'huge-monorepo-create-custom-device',
  standalone: true,
  imports: [CommonModule, MaterialModule, ReactiveFormsModule],
  templateUrl: './create-custom-device.component.html',
  styleUrl: './create-custom-device.component.scss',
  providers: []
})
export class CreateCustomDeviceComponent implements OnInit {
  customDeviceNum: FormControl<string | null> = new FormControl(null, [Validators.required]);
  teltonikaService = this.sharedTeltonikaService.getService();
  isTeltonikaCustomDevice: Boolean = false;

  constructor(
    private genericSingleton: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
    private toastr: ToastrService,
    private location: Location,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
    this.isTeltonikaCustomDevice = params['isTeltonikaCustomDevice'] === 'true';
  });
  }

  createCustomDevice() {
    if (this.isTeltonikaCustomDevice) {
      if (this.customDeviceNum.value == '' || this.customDeviceNum.value == null) {
        this.genericSingleton.service.createToast('No Device Number Entered', 'Please enter a device number', 'error');
        if (this.customDeviceNum) {
          this.customDeviceNum.markAsTouched();
        }
        return;
      }

      this.teltonikaService.createCustomTeltonikaDevice(this.customDeviceNum.value).subscribe({
          next: (resp) => {
            if (!resp) {
              this.toastr.error('Error Creating Custom Device');
            } else {
              this.toastr.success('Created Custom Device');
            }
          },
          error: (err) => {
            this.toastr.error('Error Creating Custom Device');
          }
        });
    }
  }

  cancel() {
    this.location.back();
  }
}

